import { Form } from "react-bootstrap";
import ReactSlider from "react-slider";

export default function RotationSlider(props) {

    const onChange = function(e) {
        if (props.onChange) {
            props.onChange(e);
        }
    }

    return <Form.Group controlId='input-small' className='mb-3'>
        <Form.Label className='text-body fs-sm me-0 pe-1 text-nowrap'>
            Rotation
        </Form.Label>
        <ReactSlider disabled={props.disabled} className='range-slider range-slider-single' thumbClassName='range-slider-handle' trackClassName='range-slider-track' min={0} max={360} value={props.value} ariaLabel={['Handle']} ariaValuetext={state => `Handle value ${state.valueNow}`} step={1} onChange={onChange} renderThumb={(props, state) => (
            <div {...props}>
                <div className='range-slider-tooltip'>{state.valueNow}°</div>
            </div>
        )}
        />
    </Form.Group>
}